/**
 * NavigationManager for lbbw-am.de
 * Manages responsive switching between MainMenu and MobileMenu
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */
import MainMenu from './MainMenu';
import MobileMenu from './MobileMenu';

export default class NavigationManager {
  /**
   * NavigationManager constructor
   *
   * @param {HTMLElement} element - The main navigation container
   */
  constructor(element) {
    this.element = element;
    this.breakpoint = window.AMApp?.CONSTANTS?.BREAKPOINT?.LG || 1024;
    this.isMobile = null;
    this.currentMenu = null;

    this.init();
  }

  /**
   * Initialize the navigation manager
   */
  init() {
    console.log('NavigationManager initialized');
    // Determine initial state and initialize appropriate menu
    this.updateMenuState();

    // Attach resize handler
    this.attachResizeHandler();
  }

  /**
   * Update menu state based on viewport width
   */
  updateMenuState() {
    console.log('NavigationManager updateMenuState triggered');
    const currentWidth = window.innerWidth;
    const shouldBeMobile = currentWidth <= this.breakpoint;

    // First initialization
    if (this.isMobile === null) {
      this.isMobile = shouldBeMobile;
      this.initializeMenu();
      return;
    }

    // Check if we need to switch
    if (this.isMobile !== shouldBeMobile) {
      // Switch navigation without discarding page state or pending fund data.
      this.currentMenu?.destroy();
      this.isMobile = shouldBeMobile;
      this.initializeMenu();
    }
  }

  /**
   * Initialize the appropriate menu based on viewport
   */
  initializeMenu() {
    if (this.isMobile) {
      this.currentMenu = new MobileMenu(this.element);
    } else {
      this.currentMenu = new MainMenu(this.element);
    }
  }

  /**
   * Attach window resize handler
   */
  attachResizeHandler() {
    let resizeTimeout;

    window.addEventListener('resize', () => {
      // Debounce resize events
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.updateMenuState();
      }, 250);
    });
  }

  /**
   * Destroy the navigation manager
   */
  destroy() {
    if (this.currentMenu && typeof this.currentMenu.destroy === 'function') {
      this.currentMenu.destroy();
    }
  }
}
